import { render, staticRenderFns } from "./comparison-table.vue?vue&type=template&id=d77f3bb2"
import script from "./comparison-table.vue?vue&type=script&lang=js"
export * from "./comparison-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports